import { parsePhoneNumber } from "libphonenumber-js";
import isNil from "~/kernel/validation/isNil";
import { Result } from "../monads";

type PresentOptions = {
  locale: string;
};

type ParseError = {
  code: "INVALID_PHONE";
};

export default class Phone {
  public static isValidNumber(number: string) {
    try {
      return parsePhoneNumber(number, "SE")?.isValid() || false;
    } catch {
      return false;
    }
  }

  public static toInternational(number: string): Result<string, ParseError> {
    try {
      return Result.ok(parsePhoneNumber(number, "SE").number);
    } catch {
      return Result.error({ code: "INVALID_PHONE" });
    }
  }

  public static present(number: string, options: PresentOptions) {
    const countryCode = this.toCountryCode(options.locale);
    const phoneNumber = this.tryParse(number);

    if (isNil(phoneNumber)) {
      return number;
    }

    const isInCountry = countryCode === phoneNumber.country;

    if (isInCountry) {
      return phoneNumber.format("NATIONAL");
    }

    return phoneNumber.format("INTERNATIONAL", { humanReadable: true });
  }

  private static tryParse(number: string) {
    try {
      return parsePhoneNumber(number);
    } catch {
      return null;
    }
  }

  private static toCountryCode(locale: PresentOptions["locale"]) {
    switch (locale.toLowerCase()) {
      case "sv":
        return "SE";
      case "en":
        return "US";
      case "no":
        return "NO";
      default:
        return "SV";
    }
  }
}
